import { APPDATA_REJECTED } from '../constants/appData';

export function unFetchHome() {
  return {
    type: APPDATA_REJECTED,
  };
}
